// extracted by mini-css-extract-plugin
module.exports = {"giveawaysMobileSheetContent":"GiveawaysMobileSheet_giveawaysMobileSheetContent___hkxY"};